<template>
  <div id="TermsPage">
    <div id="TopBanner">
      <div id="WhiteBanner">
        <div id="Pages">
          <router-link tag="div" to="/AboutUs"><div class="SingularPage"> About Us </div></router-link>
          <router-link tag="div" to="/OurServices"><div class="SingularPage"> Our Services </div></router-link>
          <router-link tag="div" to="/ContactUs"><div class="SingularPage"> Contact Us </div></router-link>
        </div>
        <div id="LogoZone">
          <router-link tag="div" to="/"><img id="Logo" src="../../assets/images/MIT_images/MID Logo_On Wht.png" alt="None"></router-link>
        </div>
      </div>
      <div id="ColorBanner">
        <div id="Title">Credit Application Form</div>
      </div>
    </div>
    <div id="DetailsBanner">
      Last updated: 5/8/20
      <a href="https://manageit.nz:8081/uploads/documents/Manage%20IT-%20Credit%20Application%20Form.pdf" target="_blank"><i style="font-size:24px; margin-left: 20px" class="fa">&#xf02f;</i></a>
    </div>
    <div id="ContentBanner">
      <div id="ApplicationZone">
        <p>
        Forward completed applications to either:
        <br>
        </p>
        <pre class="tab">Ph:		03-381-0333 </pre>
        <pre class="tab">Fax: 		03-381-0555 </pre>
        <pre class="tab">Post:		Manage IT Digital Limited </pre>
        <pre class="Dtab"> PO Box 16-649 </pre>
        <pre class="Dtab"> Hornby </pre>
        <pre class="Dtab"> CHRISTCHURCH </pre>
        <pre class="Dtab"> (* Must be completed for application to be processed) <br><br></pre>
        <pre style="white-space: pre-wrap; margin: initial">
*Company Name:		……………….……………….……………….……………….……………….

Trading As:		……………….……………….……………….……………….……………….
(if applicable)

Company Number: 	………………………………..

GST Number:	 	………………………………..

*Nature of Company Set-up:	……………….……………….……………….……………….……………….

*Postal Address:		……………….……………….……………….……………….……………….

        ……………….……………….……………….……………….……………….

*Delivery Address:		……………….……………….……………….……………….……………….

        ……………….……………….……………….……………….……………….

Website Address:		……………….……………….……………….……………….……………….


*Contact Names	(if same person please note)


Director:		…………………………………...		Email: …………………………………...


Technical:		…………………………………...		Email: ……………………………………

Accounts:		…………………………………...		Email: ……………………………………

Purchasing:		…………………………………...		Email: ……………………………………


Site Contact

*Name:	…………………………………...		*Phone: …………………………………….

*Title:		…………………………………...		*Email: …………………………………….





Overview of your business

Name 3 TRADE REFERENCES (Suppliers)
(Please note that no references will be contacted without prior approval from your company)




1	………………..………………..………………..		Phone: ………………..………………..




2	………………..………………..………………..		Phone: ………………..………………..




3	………………..………………..………………..		Phone: ………………..………………..




Company Email Notifications

Manage IT Digital Ltd provide regular updates on technologies via newsletters.  The notifications are informative and provide insight into what is currently occurring within the IT industry.  If you would like to be removed from this notification then please tick the following box. [ ]

Please note that you unsubscribe from the newsletter at anytime by selecting unsubscribe within the newsletter.







        </pre>


      </div>



      <p style="font-size: 40px"><b>Terms Of Business</b></p>
      <p>
      <br><b>General</b><br>
      The following constitutes the terms of business between Manage IT Digital Limited (herein after referred to as MIT) and the client.  MIT may vary these conditions without notice.
      <br><br>
      <b>Payment</b><br>
      Upon approval of trading account, invoices shall be paid in full by the 20th of the following month with the exception of purchases of hardware or software items valued from $1000 - $5000 in total for which payment shall be made in full upon receipt of goods.  For purchases exceeding $5000 in total value a 50% deposit is required upon placement of order and the balance is payable upon receipt of goods.  Where the client has no trading account payment for all goods and services shall be made in full prior to delivery.  MIT reserves the right to charge penalty interest on accounts not paid on the due date and the client shall be liable for any collection fees incurred in recovery of the debt.  No part of the payment due is to be retained by the Purchaser.  Where all goods are not immediately available, any retention will be agreed in writing but will be no greater than the value of the goods not supplied.  Pricing is quoted exclusive of GST and cost of freight.  MIT only accepts payment in cash, cheque or direct credit.  Where accounts are not paid by due date, MIT may withhold services at its discretion.
      <br><br>
      <b>Warranty</b><br>
      MIT guarantees all new products for a period of 60 days, or for the period of the manufacturer’s warranty, whichever is longer.  Repairs to faults, which are not intermittent, are guaranteed for a period of 60 days.  For reasons detailed below, no warranty can be given to intermittent faults.  Warranty is provided subject to:<br>
      <ul>
      <li>Equipment being properly used and maintained.</li>
      <li>Damage or fault is not due to outside influences (such as power surges) or user error.</li>
      <li>Warranty on replacement equipment applies from the date of original purchase of the equipment that was replaced under warranty.</li>
      <li>Manufactured warranty does not cover MIT’s associated labour costs.</li>
      <li>Any attempt to undertake service on product supplied by MIT by a third party not authorised by MIT will render the warranty invalid.</li>
      </ul>
      <br>
      <b>Intermittent Faults</b><br>
      Because of the intermittent nature of many computer faults, it is often impossible to diagnose a fault other than a series of replacements and/or testing of different components.  The non-appearance of an intermittent fault during workshop testing does not mean that the fault has actually been fixed.  A successful repair may therefore involve a long period with the equipment being returned several times before the fault is finally eliminated.  In many cases, the problem may lie within a change to the environment rather than an actual repair to the equipment.  MIT service personnel will do their best to eliminate the most likely reasons first, but all time will be charged for.
      <br><br>
      <b>Consumer Guarantees Act 1993</b><br>
      It is acknowledged that where the client is acquiring products or services for the purposes of business use, the provisions of the Consumer Guarantees Act 1993 shall apply.
      <br><br>
      <b>Privacy</b><br>
      MIT will handle client’s personal information in accordance with the relevant laws.
      <br><br>
      <b>Charges</b><br>
      A minimum of 15 minutes applies to telephone support and service calls.  Where the service and/or support work is required outside core business hours of 8:30 am to 5:00 pm, or on statutory days and weekends, unless specifically agreed MIT will charge at out of hours charge out rates.  Travel will be charged by Zone as per current price schedule, where Zone 1 = Within 5km of MIT Hornby (HO) premise or within the 4 Avenues of the CBD, Zone 2 = Within 20km of MIT (HO) premises but outside of Zone 1, Zone 3 = Within Canterbury region, Zone 4 = Outside of Canterbury region.  MIT may vary its charge out rates at its discretion.
      <br><br>
      <b>Backup of Data and Programmes</b><br>
      While every effort is made to ensure the integrity of data on a client’s system, at times problems may arise.  It is the responsibility of the client to maintain an adequate backup and security of data at all times.
      <br><br>
      <b>Priority</b><br>
      While MIT tries to ensure sufficient resources to expedite repair, there are times when resources are limited.  On such occasions, priority for repairs, parts and/or loan equipment will go to those clients whose equipment is covered by a MIT Support Contract.
      <br><br>
      <b>Support</b><br>
      Unless specifically agreed, training and application support for software is not provided.
      <br><br>
      <b>Ownership</b><br>
      Goods will remain the property of MIT until fully paid for, but risk shall pass to the client  when such goods are delivered to the client or into custody on the client’s behalf.  Once pre-packaged software is opened, under no circumstances will it be accepted for return.
      <br><br>
      <b>Software Licensing, Viruses, Security</b><br>
      MIT will not knowingly recommend illegal software to the client or recommend licence levels lower than those actually required.  It is the client’s responsibility to ensure that all software purchased or obtained is both legal and virus free.  MIT will not be held responsible or liable for software piracy, licensing violations, security breeches or viruses occurring within the client’s system.  If the product supplied is a software product, then in addition to these terms, that product is supplied subject to the terms and conditions relevant to the software licence agreement.
      <br><br>
      <b>Liability</b><br>
      MIT employees, contractors or agents will not be liable in contract, tort (including negligence) or otherwise to compensate you or any employees or agents thereof for any loss, injury or damage arising directly or indirectly from any omission, error, default or delay by MIT employees, contractors or agents or for failure of services provided – except where loss, injury or damage is a direct or indirect result of an intentional act.  Such loss (whether direct or indirect) includes loss of profits, revenue, actual or potential business opportunities, contracts or anticipated savings or profits or any indirect or consequential loss whatsoever, notwithstanding that MIT employees, contractors or agents have been advised of the likelihood of such losses.
      <br><br>
      <b>Intellectual Property</b><br>
      All trademarks, copyright and other intellectual property embodied in or in connection with product, service, software and any related documentation are the sole property of MIT or its suppliers and cannot be disclosed to any third parties without written consent from MIT.
      <br><br>


      </p>
      <pre style="white-space: pre-wrap;">
“I/We irrevocably authorise any person or company to provide you with such information as you may require in response to your credit and/or employment inquiries.  I/We further irrevocably authorise you to furnish to any third party, details of this application and any subsequent dealings that I/we may have with you as a result of this application being actioned by you.”




Name:	………….………..………………..………….………..………………....………………..




Signature:	………….………..………………..		Date: ………………..………………..




Title:		………….………..………………..






“I/We have read and accept the Manage IT Digital Limited Terms of Business.”




Name:	………….………..………………..………….………..………………....………………..




Signature:	………….………..………………..		Date: ………………..………………..




Title:		………….………..………………..


      </pre>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>

    import Footer from "../Footer";
    export default {
        name: "TermsOfBussiness",
        components: {Footer}
    }
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
#TermsPage {
  background-color: whitesmoke;
  font-family: 'Open Sans', sans-serif;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}
#TopBanner {
  min-height: 230px;
  max-height: 450px;
  width: 100vw;
  margin-bottom: 40px;
  position: relative;
}
#WhiteBanner {
  background: #FFF;
  height: 70px;
  border-bottom: dimgray solid 4px;
  box-shadow: 5px 0px 5px black;
  z-index: 2;
  position: relative;
}
#ColorBanner {
  background: #0070d0;
  min-height: 230px;
  max-height: 450px;
  width: 100vw;
  z-index: 1;
}
  #Pages {
    color: white;
    position: absolute;
    left: 15%;
    top: 30%;
    display: flex;
    flex-direction: row;
  }

  .SingularPage {
    margin: 0 5px;
    min-width: 150px;
    font-size: 17px;
    //font-weight: 700;
    opacity: 0.7;
    transition: 0.4s;
    color: black;
  }
  .SingularPage:hover {
    opacity: 1;
    cursor: pointer;
  }
  #LogoZone {
    position: absolute;
    //bottom: 0;
    left: 2%;
    top: 1%;
  }
  #Logo {
    width: 200px;
  }
  #Title {
    position: absolute;
    top: 50%;
    left: 9%;
    font-size: 90px;
    color: whitesmoke;
  }
  #ContentBanner {
    margin: 20px 10%;
    text-align: left;
    font-size: 20px;

  }
  #DetailsBanner {
    color: black;
    opacity: 0.5;
    margin: 0 10%;
    padding: 0;
    text-align: left;
  }
  .wrapper {
    margin: initial !important;
  }
  #Logo:hover {
    cursor: pointer;
  }
  .tab {
    margin-left: 60px;
  }
  .Dtab {
    margin-left: 200px;
  }
</style>